import { render, staticRenderFns } from "./ProfileInput.vue?vue&type=template&id=6745221e&scoped=true"
import script from "./ProfileInput.vue?vue&type=script&lang=js"
export * from "./ProfileInput.vue?vue&type=script&lang=js"
import style0 from "./ProfileInput.vue?vue&type=style&index=0&id=6745221e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745221e",
  null
  
)

export default component.exports